import { Maintenance } from 'core/types/maintenance';

import usePaginationHandler from './usePaginationHandler';

export default function useVehicleMaintenances(vehicleId: number) {
  return usePaginationHandler<Maintenance>(
    vehicleId === undefined ? undefined : `vehicles/${vehicleId}/maintenances`
  );
}
